import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {
    TransactionDetailTurnCashList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/TransactionDetailTurnCash/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transactionDetailTurnCash.js